<div class="d-none d-xl-block">
    <ul
      style="border-radius: 5px"
      ngbNav
      #nav="ngbNav"
      [(activeId)]="active"
      class="nav-tabs bg-semi-light d-flex px-5 align-items-center" [ngClass]="ngClass">
      <li *ngFor="let tab of tabData" [ngbNavItem]="tab.id" class="" [ngClass]="listClass">
        <div
          class="{{tab.id === 22 || tab.id === 33 ?'cursor-not-allowed':'hand'}}"
          [ngClass]="active === tab.id ? 'active-button' : 'not-active'"
          (click)="onTabClick(tab.id)"
          ngbNavLink>
          <!-- (click)="activeTab(tab.id)" -->
          {{ tab.label }}
        </div>
        <ng-template ngbNavContent>
          <ng-container *ngComponentOutlet="tab.component"></ng-container>
        </ng-template>
      </li>
    </ul>
</div>

<!-- ********************************FOR RESPONSIVE IPAD PRO***************************************************** -->
<div class="m-t-15 d-block d-xl-none">
  <div class="custom-dropdown mb-2 position-relative">
    <div class="selected-option text-center text-nowrap " (click)="toggleDropdown()">
      <span class="pe-2">{{ getSelectedTabLabel() }}</span>
      <img *ngIf="!dropdownOpen" style="transform: rotate(90deg);" src="../../../../../../assets/SVGIcons/Arrow---Right-Circle.svg" alt="">
      <img *ngIf="dropdownOpen" style="transform: rotate(-90deg);" src="../../../../../../assets/SVGIcons/Arrow---Right-Circle.svg" alt="">
    </div>
    <div class="col-12 dropdown-options position-absolute" style="z-index: 10;" *ngIf="dropdownOpen">
      <div *ngFor="let tab of tabData">
        <div>
          <div
            [ngClass]="{
              'active-button': active === tab.id,
              'not-active': active !== tab.id,
              'cursor-not-allowed' : active !== tab.id
            }"
            (click)="selectTab(tab.id)"
          >
            {{ tab.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div [ngbNavOutlet]="nav" class="mt-3 h-100" [ngClass]="tabClass"></div>
  